<app-dialog-container>
  <h1 class="dialog-title">
    <mat-icon>info</mat-icon>
    Informações do Plano
  </h1>

  <div mat-dialog-content class="dialog-content">
    
    <div class="details-row">
      
      <div class="info-section description-section">
        <div class="section-header">
          <mat-icon>description</mat-icon>
          <h3>Descrição do Plano</h3>
        </div>
        <div class="section-content description-content">
          <p *ngIf="element.planDescription && element.planDescription.trim() !== ''; else noDescription">
            {{ element.planDescription }}
          </p>
          <ng-template #noDescription>
            <p class="no-description">
              <mat-icon>info_outline</mat-icon>
              Nenhuma descrição disponível
            </p>
          </ng-template>
        </div>
      </div>

      <div class="info-section partners-section">
        <div class="section-header">
          <mat-icon>handshake</mat-icon>
          <h3>Parceiros Envolvidos</h3>
        </div>
        <div class="section-content partners-content">
          
          <div class="partners-list" *ngIf="element.partners; else noPartners">
            <div  class="partner-item">
              <mat-icon>business</mat-icon>
              <span>{{ element.partners}}</span>
            </div>
          </div>

          <ng-template #noPartners>
            <div class="no-partners">
              <mat-icon>info_outline</mat-icon>
              <p>Nenhum parceiro vinculado</p>
            </div>
          </ng-template>
        </div>
      </div>

    </div> <div class="info-section audit-section">
      <div class="section-header">
        <mat-icon>history</mat-icon>
        <h3>Histórico de Atualizações</h3>
      </div>
      <div class="section-content">
        <div class="audit-list">
          <div *ngFor="let item of element.audits" class="audit-item">
            <div class="audit-header">
              <span class="audit-date">
                <mat-icon>event</mat-icon>
                {{ item.createdAt | date : 'dd/MM/yyyy HH:mm' }}
              </span>
              <span class="audit-user">
                <mat-icon>person</mat-icon>
                {{ item.createdBy?.firstName }}
              </span>
            </div>
            <div class="audit-reason">
              {{ item.reason }}
            </div>
          </div>

          <div *ngIf="!element.audits?.length" class="no-audits">
            <mat-icon>info_outline</mat-icon>
            <p>Nenhuma atualização registrada</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</app-dialog-container>